module.exports = __webpack_public_path__ + "static/media/empty-set.2b301a7b.svg";